import Roundy from "./roundy";
const WodRemaining = wod => {
  var remaining;
  let supplements = wod.supplements ? parseFloat(wod.supplements) : 0;
  let negotiated = wod.negotiated ? parseFloat(wod.negotiated) : 0;
  let prevYearAdj = wod.prevYearAdj ? parseFloat(wod.prevYearAdj) : 0;
  let derivBudget = wod.derivBudget ? parseFloat(wod.derivBudget) : 0;
  let budget = wod.budget ? parseFloat(wod.budget) : 0;
  var totalcharges = 0;
  if (
    wod.dailylaborentries &&
    wod.dailylaborentries.length &&
    wod.dailylaborentries[0]
  ) {
    wod.dailylaborentries.map(
      entry => (totalcharges += entry.hours * parseFloat(entry.payrate))
    );
  }
  console.log("wod total charges $", totalcharges);
  if (
    wod.dailymaterialentries &&
    wod.dailymaterialentries.length &&
    wod.dailymaterialentries[0]
  ) {
    wod.dailymaterialentries.map(entry => {
      if (entry.markuppercent) {
        totalcharges += entry.amount * entry.markuppercent;
      } else {
        totalcharges += entry.amount * entry.markuppercent;
      }
    });
  }
  if (wod.workOrderNbr.length > 7) {
    remaining =
      budget + supplements + negotiated - (prevYearAdj + totalcharges);
  } else {
    remaining = budget + supplements + negotiated;
    var negatives = prevYearAdj;
    negatives += totalcharges;
    negatives += derivBudget;
    remaining -= negatives;
  }
  return Roundy(remaining);
};
export default WodRemaining;



// WEBPACK FOOTER //
// ./src/services/wodremaining.js